import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as moment from "moment";
import { FC, createRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import TableComponent from "../../../core/components/table/table.component";
import HasPermission from "../../../core/guards/has-permission";
import FilterFormComponent, {
  FilterFormConfig,
} from "../../../shared/filter-form/filter-form.component";
import {
  downloadUserActivityReportsFile,
  getUserList,
  setFilter,
} from "../../../store/slices/fault-module/user-activity.slice";

import { B2Button } from "@hdb/biome-2";
import pdfIcon from "../../../assets/images/pdfBiomeIcon.svg";
import spreadsheetIcon from "../../../assets/images/spreadsheetIconBiome.svg";
import { Spinner } from "react-bootstrap";
interface UserActivityReportTableComponentProps {
  columns: any;
  data: any[];
  totalNumberOfRecords: number;
  pageSize: number;
  current: number;
  onChangePage: any;
  onChangeSort: any;
  onRefetchData: (
    // tcCode: any,
    // siteCode: any,
    // blockCode: any,
    userId: any,
    startDate: any,
    endDate: any
  ) => void;
}

const UserActivityReportTableComponent: FC<
  UserActivityReportTableComponentProps
> = ({
  columns,
  data,
  totalNumberOfRecords,
  pageSize,
  current,
  onChangePage,
  onChangeSort,
  onRefetchData,
}) => {
    const formRef = createRef();
    const [isFiltered, setIsFiltered] = useState<any>(false);
    const [userOptions, setUserOptions] = useState<any>([]);
    const [downloaDocumentPayload, setDownloaDocumentPayload] = useState<any>({
      userId: "",
      startDate: "",
      endDate: "",
    });

    const [filterUpdateCount, setFilterUpdateCount] = useState(0);

    const dispatch = useDispatch();

    useEffect(() => {
      dispatch(getUserList());
    }, [dispatch]);

    const userData = useSelector((state: any) => {
      return state.userActivityReport.userList;
    });
    const isLoadingUserActivityReportsDownload = useSelector((state: any) => {
      return state.userActivityReport.isLoadingUserActivityReportsDownload;
    });

    useEffect(() => {
      const users = userData?.data?.map((user: any) => ({
        label: user?.profileName,
        value: user?.id,
      }));

      if (users?.length > 0) {
        users.unshift({
          label: "All",
          value: null,
        });
      }

      setUserOptions(users);
    }, [userData]);

    const onSubmitFilter = () => {
      const form: any = formRef.current;

      if (form) {
        form.handleSubmit();

        const { userId, startDate, endDate } = form.values;

        if (!startDate) {
          return;
        }

        if (endDate) {
          if (endDate < startDate) {
            setIsFiltered(false);
            return;
          }
        }

        dispatch(setFilter(form.values));

        onRefetchData(
          userId ? userId : null,
          startDate ? moment.utc(startDate) : null,
          endDate ? moment.utc(endDate) : null
        );

        setDownloaDocumentPayload({
          userId,
          startDate,
          endDate,
        });

        setIsFiltered(true);
      }
    };

    const onClickDownload = (fileType: any) => {
      const form: any = formRef.current;

      if (form) {
        // form.handleSubmit();

        const { userId, startDate, endDate } = downloaDocumentPayload;

        if (!startDate) {
          return;
        }

        dispatch(
          downloadUserActivityReportsFile({
            fileType,
            userId: userId ? userId : null,
            startDate: startDate ? moment.utc(startDate) : null,
            endDate: endDate ? moment.utc(endDate) : null,
          })
        );
      }
    };

    const onChangeStartDate = (startDate: any) => {
      setFormFilterInitialValues((prevInitValues: any) => ({
        ...prevInitValues,
        startDate: startDate,
      }));
    };

    const onChangeEndDate = (endDate: any) => {
      setFormFilterInitialValues((prevInitValues: any) => ({
        ...prevInitValues,
        endDate: endDate,
      }));
    };

    const [formFilterInitialValues, setFormFilterInitialValues] = useState({
      userId: "",
      startDate: "",
      endDate: "",
    });

    const onReset = () => {
      const form: any = formRef.current;
      form.resetForm();

      setFilterUpdateCount(filterUpdateCount + 1);

      setIsFiltered(false);
      setFormFilterInitialValues({
        userId: "",
        startDate: "",
        endDate: "",
      });
    };

    const filterActionConfig: any = {
      label: "Search",
      event: onSubmitFilter,
      variant: "primary",
    };

    const reset: any = {
      label: "Reset",
      event: onReset,
      variant: "secondary",
    };

    const emptyConfig = {
      title: "No User Activity Found",
      description: "",
    };
    const currentDateTime = moment().format("YYYY-MM-DD");
    const date13MonthsAgo = moment().subtract(13, "months").format("YYYY-MM-DD");
    const yesterdayDateTime = moment().subtract(1, "day").format("YYYY-MM-DD");

    const filterFormConfig: FilterFormConfig = {
      controls: [
        {
          controlGroup: [
            {
              name: "startDate",
              placeholder: "Select Start Date *",
              type: "date",
              required: true,
              isLoading: false,
              onChange: onChangeStartDate,
              minDate: date13MonthsAgo,
              maxDate: currentDateTime,
            },
          ],
        },
        {
          controlGroup: [
            {
              name: "endDate",
              placeholder: "Select End Date",
              type: "date",
              required: true,
              isLoading: false,

              onChange: onChangeEndDate,
              minDate: date13MonthsAgo,
              maxDate: currentDateTime,
            },
          ],
        },
        {
          controlGroup: [
            {
              name: "userId",
              placeholder: "Select User",
              type: "searchable-select",
              selectType: "single",
              options: userOptions,
              required: true,
              isLoading: false,
            },
          ],
        },
      ],
    };

    const navigate = useNavigate();

    const redirectToConfiguration = () => {
      navigate("/admin/configuration/reportconfiguration");
    };

    const validationSchema = yup.object().shape({
      startDate: yup.date().required("Start Date is required"),
      endDate: yup
        .date()
        .min(yup.ref("startDate"), "End Date must be after Start Date"),
    });

    return (
      <div>
        {/*       <div className="flex justify-end table-generic-action mb-2">
        <B2Button
          className="icon-text-btn"
          variant="primary"
          onClick={redirectToConfiguration}
        >
          Automatic Report Scheduler
          <FontAwesomeIcon icon={faCalendar} className="fs-7 ms-2" />
        </B2Button>
      </div> */}

        <div>
          <FilterFormComponent
            formRef={formRef}
            initialValues={formFilterInitialValues}
            formConfig={filterFormConfig}
            actionConfig={filterActionConfig}
            resetButton={reset}
            validation={validationSchema}
            filterUpdateCount={filterUpdateCount}
          />
        </div>
        <div>
          {isFiltered && (
            <div className="my-3">
              <div className="export py-4 d-flex align-items-center justify-content-end">
                <HasPermission
                  moduleName="User Activity Report"
                  actionName="Download-User Activity Report"
                  isRoute={false}
                >
                  <div className="d-flex gap-2">
                    <B2Button
                      variant="light"
                      onClick={() => onClickDownload("downloadPdf")}
                      disabled={
                        !data || (Array.isArray(data) && data.length === 0)
                      }
                    >
                      <img className="fs-7 ms-2" src={pdfIcon} alt="PDF Icon" />{" "}
                      Export as PDF
                    </B2Button>

                    <B2Button
                      variant="light"
                      onClick={() => onClickDownload("downloadExcel")}
                      disabled={
                        !data || (Array.isArray(data) && data.length === 0)
                      }
                    >
                      <img
                        className="fs-7 me-2"
                        src={spreadsheetIcon}
                        alt="Spreadsheet Icon"
                      />{" "}
                      Export as Excel
                    </B2Button>
                  </div>
                  {isLoadingUserActivityReportsDownload ? (
                    <Spinner
                      className="ms-2"
                      style={{ color: "#1976D2" }}
                      animation="border"
                      role="status"
                      size="sm"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  ) : null}
                </HasPermission>
              </div>
              <TableComponent
                tableHeaders={columns}
                emptyConfig={emptyConfig}
                data={data}
                totalNumberOfRecords={totalNumberOfRecords}
                pageSize={pageSize}
                current={current}
                onChangePage={onChangePage}
                onChangeSort={onChangeSort}
              />
            </div>
          )}
        </div>
      </div>
    );
  };

export default UserActivityReportTableComponent;
